/**
 * 客服联系方式配置
 * 集中管理所有客服相关的联系信息
 */

export const CONTACT_CONFIG = {
  // 客服热线
  serviceHotline: '+86 21 5077 7029',

  // 客服邮箱
  supportEmail: 'marketing@bravowhale.com',

  // 工作时间
  workingHours: '周一至周五 9:00-18:00',
} as const;
